import { defineMessages } from 'react-intl';

export const editableBasePriceMessages = defineMessages({
  notificationAutoSetMinMax: {
    defaultMessage:
      'Der gültige Wertebereich für eine Ratenberechnung liegt zwischen {minValue} und {maxValue}. Der Preis wurde automatisch für dich angepasst.',
    id: 'ic-editableBasePrice-notification-minMax',
  },
  notificationAutoSetMin: {
    defaultMessage:
      'Der Preis wurde automatisch für dich angepasst. Der Minimalbetrag muss {minValue} betragen.',
    id: 'ic-editableBasePrice-notification-min',
  },
});
